( function () {
  'use strict';

  var reduced =
    window.matchMedia &&
    window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

  function initLibraryDeep( root ) {
    var sid = root.getAttribute( 'data-section-id' );
    var noise = document.getElementById( 'library-deep-noise-' + sid );
    if ( reduced || ! noise ) {
      root.classList.add( 'library-deep--static' );
      return;
    }

    var t0 = performance.now();
    var running = false;

    function tick( now ) {
      if ( ! running ) {
        return;
      }
      var t = ( now - t0 ) / 1000;
      var fx = 0.018 + Math.sin( t * 0.9 ) * 0.006;
      var fy = 0.055 + Math.cos( t * 0.7 ) * 0.012;
      noise.setAttribute( 'baseFrequency', fx.toFixed( 4 ) + ' ' + fy.toFixed( 4 ) );
      requestAnimationFrame( tick );
    }

    if ( 'IntersectionObserver' in window ) {
      var obs = new IntersectionObserver(
        function ( entries ) {
          running = entries[ 0 ] && entries[ 0 ].isIntersecting;
          if ( running ) {
            requestAnimationFrame( tick );
          }
        },
        { threshold: 0.25 }
      );
      obs.observe( root );
    } else {
      running = true;
      requestAnimationFrame( tick );
    }
  }

  document.addEventListener( 'DOMContentLoaded', function () {
    document.querySelectorAll( '[data-library-deep]' ).forEach( initLibraryDeep );
  } );
}() );
